<template>
  <div>
   <b-carousel
        :ref="slideId"
        :id="slideId"
        v-model="slide"
        :interval="interval"
        :controls="controls"
        :indicators="indicators"
        background="#FFFFFF"
        @sliding-start="handleSlidingStart"
        @sliding-end="handleSlidingEnd"
        :no-touch="noTouch"
        :fade="fadeTransition"
    >
      <b-carousel-slide
          v-for="(doc, i) in logDocsAll"
          :caption="`Doc ${i+1}`"
          :key="i"
          #img
      />
     <b-card
         :img-src="doc"
         img-alt="Card image"
         img-right
     >
       <b-card-text>
         Some quick example text to build on the card and make up the bulk of the card's content.
       </b-card-text>
     </b-card>
    </b-carousel>
  </div>
</template>
<script>
import TipTapOutput from "@/components/common/tipTapOutput";

export default {
  name: "CallLog_DocsView",
  components: {},
  props: {
    components:{
      TipTapOutput
    },
    resource: {
      type: Object,
      default: () =>{},
      required: false
    },
    items: {
      type: Array,
      default: () => [ { phone: 3106214068, name: 'Appeal Note', notes: 'Thee are my notes about the call' },],
      required: false
    },
    logDocsAll:{
      type: Array,
      default: () => [],
      required: false
    },
  },
  created() {},
  mounted() {},
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    /* DATA */
  },
  methods: {
    handleGoBack(){
      this.$refs[this.slideId].setSlide(0);
    },
    handleLogTableRowClick(logObj){
      //Go to Detail View
      this.selectedLog = logObj;
      this.$refs[this.slideId].setSlide(1);
    },
    handleGoToDocsViewClick(){
      this.$refs[this.slideId].setSlide(2);
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTp) {},
  },
  data() {
    return {
      /* SLIDE INFO*/
      slideId: "audioSlides",
      interval:3000,
      controls: false,
      indicators: false,
      noTouch: false,
      fadeTransition: true,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
